import { Web3Provider } from '@ethersproject/providers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLibrary(provider: any) {
  // this will vary according to whether you use e.g. ethers or web3.js
  return new Web3Provider(provider);
}
